<template>
  <el-dialog v-model="drawer" width="30%">
    <template #title>
      <div class="question-row">推荐码</div>
    </template>
    <div class="dataInput">
      <el-form :model="formData" ref="formRef" :rules="rules">
        <el-form-item prop="input">
          <el-input @input="(v) => (formData.input = v.replace(/[^\d]/g, ''))" maxlength="6" v-model="formData.input" placeholder="请输入推荐码" />
        </el-form-item>
        <div class="invitationCode">
          指管管安全服务人员的服务ID，用于识别服务人员与您的关系，以便于后续开展良好的服务工作，若服务人员告知，请将推荐码填写此中。
        </div>
      </el-form>
    </div>

    <template #footer>
      <span class="dialog-footer">
        <div class="dataButton orangeButton">
          <el-button :loading="loading" @click="updateCode"> 完成 </el-button>
        </div>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, computed, reactive } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { updateCurrentUserInvitationCode } from "@/http/api/workbench";

const router = useRouter();
let store = useStore();
let route = useRoute();

let userData = computed(() => {
  return store.state.auth.userData;
});

let formRef = ref(null);
let drawer = ref(false);
let loading = ref(false);
let formData = reactive({ input: "" });

const rules = {
  input: [
    {
      required: true,
      message: "请输入推荐码",
      trigger: [""]
    }
  ]
};
//打开侧边栏
const changedrawer = () => {
  drawer.value = true;
  formData.input = userData.value.invitationCode;
};

//更新邀请码
const updateCode = (index) => {
  formRef.value.validate(async (valid) => {
    if (valid) {
      loading.value = true;
      await updateCurrentUserInvitationCode({ invitationCode: formData.input })
        .then((res) => {
          if (res && res.code == "00000") {
            store.dispatch("auth/getUserInfoNoMessage");
            drawer.value = false;
            setTimeout(() => {
              loading.value = false;
            }, 500);
            ElMessage.success("推荐码修改成功");
            formData.input = userData.value.invitationCode;
          } else {
            formData.input = userData.value.invitationCode;
          }
        })
        .catch(() => {
          loading.value = false;
        });
    }
  });
};
defineExpose({
  changedrawer
});
</script>
<style lang="scss" scoped>
.question-row {
  display: flex;
  align-items: center;
  .question-iocn {
    width: 18px;
    height: 18px;
    margin-right: 2px;
    cursor: pointer;
  }
}
.invitationCode {
  padding: 20px 0 !important;
}
.draHeader {
  display: flex;
  justify-content: space-evenly;
  text {
    color: #fff;
  }
  .once {
    cursor: pointer;
    position: relative;
  }
  .active {
    &::after {
      position: absolute;
      left: 50%;
      bottom: -21px;
      transform: translateX(-50%);
      content: "";
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid #fff;
      margin-top: 10px;
    }
  }
}

.userId {
  &_first {
    margin: 20px;
    border-bottom: 2px solid $border-color-common;
    &_title {
      display: flex;
      justify-content: space-between;
      span {
        color: #bdbdbd;
      }
      text {
        cursor: pointer;
        color: $text-color-orange;
      }
    }
    &_data {
      display: flex;
      padding: 25px 0;
      align-items: center;
      .peopleData {
        margin-left: 30px;
        color: #4f4f4f;
        .id {
          margin-bottom: 5px;
        }
      }
    }
  }
  &_second {
    margin: 20px;
    border-bottom: 2px solid $border-color-common;
    &_title {
      display: flex;
      justify-content: space-between;
      span {
        color: #bdbdbd;
      }
      text {
        cursor: pointer;
        color: $text-color-orange;
      }
    }
    &_data {
      display: flex;
      padding: 25px 0;
      align-items: center;
      .dataInput {
        flex: 1;
      }
      .dataButton {
        padding: 0 10px;
      }
    }
  }
}
</style>
